<template>
    <div class="h-48 flex flex-wrap content-center items-center">
      <h1 class="m-auto">Loading...</h1>
      <div class="stage">
        <div class="box bounce-7">
          <img src="/ms-icon-310x310.png" alt="">
        </div>
      </div>
    </div>
  </card>
</template>

<script>
export default {
}
</script>

<style>
.stage {
  display: grid;
  height: 330px;
  width: 100%;
}
.box {
  align-self: flex-end;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  /*background-color: #F44336;*/
  height: 200px;
  margin: 0 auto 0 auto;
  transform-origin: bottom;
  width: 200px;
}
.bounce-7 {
  animation-name: bounce-7;
  animation-timing-function: cubic-bezier(0.280, 0.840, 0.420, 1);
}
@keyframes bounce-7 {
  0%   { transform: scale(1,1)      translateY(0); }
  10%  { transform: scale(1.1,.9)   translateY(0); }
  30%  { transform: scale(.9,1.1)   translateY(-100px); }
  50%  { transform: scale(1.25,.85) translateY(0); }
  57%  { transform: scale(1,1)      translateY(-7px); }
  64%  { transform: scale(1,1)      translateY(0); }
  100% { transform: scale(1,1)      translateY(0); }
}
</style>
